import { getChildrenByTagName } from "@courses-pm2/api/src/ts/parser/getChildrenByTagName";

/**
 * Helper that'll extract a meta value from the node.
 */
export function getMetaValue(node: Element, value: string): string | undefined {
    const meta = getChildrenByTagName(node, "MetaText")[0];

    // Bail out if we were unable to find a reference to the meta wrapper
    if (!meta) {
        return undefined;
    }

    // ... Otherwise return the desired value
    const valueNode = meta.querySelector(value);

    // Bail out if unable to find the value
    if (!valueNode || valueNode.getAttribute("show-out-of-context") !== "true") {
        return undefined;
    }

    return valueNode.textContent || undefined;
}
